var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 9.8H12.8C13.1183 9.8 13.4235 9.67357 13.6485 9.44853C13.8736 9.22348 14 8.91826 14 8.6V3.2C14 2.88174 13.8736 2.57652 13.6485 2.35147C13.4235 2.12643 13.1183 2 12.8 2H7.4C7.08174 2 6.77652 2.12643 6.55147 2.35147C6.32643 2.57652 6.2 2.88174 6.2 3.2V3.8M8.6 6.2H3.2C2.53726 6.2 2 6.73726 2 7.4V12.8C2 13.4627 2.53726 14 3.2 14H8.6C9.26274 14 9.8 13.4627 9.8 12.8V7.4C9.8 6.73726 9.26274 6.2 8.6 6.2Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-copy-icon.2132b928763e1ad77f22aabbb8b8dfc9.svg";